<template>
  <div class="price-table-modal" v-if="isVisible" @click.self="close">
    <div class="price-table-content">
      <img src="@/assets/pricedisplay.png" alt="Price Table" class="price-table-image">
      <button class="close-button" @click="close">×</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceTable',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.price-table-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.price-table-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.price-table-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.close-button {
  position: absolute;
  top: -20px;
  right: -20px;
  background: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style> 